import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { GeneralService } from 'src/app/services/general.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-by-auth-code-redirect',
    templateUrl: './by-auth-code-redirect.component.html',
    styleUrls: ['./by-auth-code-redirect.component.scss'],
    standalone: false
})
export class ByAuthCodeRedirectComponent {

     routeParams: ParamMap = {} as ParamMap;
     authCode: string = '';
     deepLink: string = `${environment.BASE_URL}`;

     constructor (private route: ActivatedRoute,
          public router: Router,
          private generalService: GeneralService,
          private authService: AuthenticationService
     ) {
          
          var params = this.generalService.getQueryParameters(this.router.url);
          if (params && params['authCode']) {
               this.authCode = params['authCode']
               this.deepLink += '/byAuthCode/' + this.authCode;
               this.authService.setDeepLink(this.deepLink);
          }
     }

     ngOnInit(): void {
          this.routeParams = this.route.snapshot.queryParamMap;
          this.router.navigateByUrl('/byAuthCode/' + this.authCode);
     }
}

